module.exports = __webpack_public_path__ + "img/smartpass-logo.8ee4fa4e.png";